export { default as reducer } from './phone.ducks';



// WEBPACK FOOTER //
// ./src/routes/Phone/index.ts